// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'document';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M16.498 16.313a1.125 1.125 0 0 1-1.125 1.125H1.907a1.125 1.125 0 0 1-1.125-1.125V1.688A1.125 1.125 0 0 1 1.907.563h11.25c.294 0 .575.114.785.319l2.217 2.162a1.124 1.124 0 0 1 .339.806z'
  />
);

export const viewBox = '0 0 18 18';
